import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useI18nFormatters } from 'hooks/i18nFormatters';
import WrapperCollapsePanel from '../WrapperCollapsePanel';
import RenderFlagsOfCompany from '../RenderFlagsOfCompany';
import CompanyInfoSourcesPopover from '../SourcesPopover';

import './styles.less';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.companyInfo.businessIdentity';

const BusinessIdentityComponent = ({
  businessIdentityData,
  collapseOpened = false,
  hideRiskFactors = false,
  hideAttributes = false,
}) => {
  const { t: translate } = useTranslation();
  const { i18nFormatDateOnly } = useI18nFormatters();

  return (
    <div className="company-info-business-identity">
      <div className="title">
        <h3>
          {translate(`${I18N_BASE_PATH}.title`, 'Company identification information')}
        </h3>
        <div className="identification-company">
          <b>{businessIdentityData.name}</b>
          <RenderFlagsOfCompany countries={businessIdentityData?.countries} />
        </div>
        <Row className="content">
          <Col span={12} className="flex-column-content">
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.identifier`,
                    'Identifier'
                  )}
                </strong>
              </Col>
              <Col className="col-info">{businessIdentityData.identifier || '-'}</Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.bussinessPurpose`,
                    'Bussiness Purpose'
                  )}
                </strong>
              </Col>
              <Col className="col-info">{businessIdentityData.businessPurpose}</Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.address`,
                    'Address'
                  )}
                </strong>
              </Col>
              <Col className="col-info">{businessIdentityData.address}</Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.names`,
                    'Names'
                  )}
                </strong>
              </Col>
              <Col className="col-info">
                {businessIdentityData.names.map((name) => (
                  <>
                    <span>{name}</span> <br />
                  </>
                ))}
              </Col>
            </Row>
            <Row className="start-center">
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.sources`,
                    'Sources'
                  )}
                </strong>
              </Col>
              <Col className="col-info">
                <CompanyInfoSourcesPopover sources={businessIdentityData.sources}>
                  {businessIdentityData.sources.length}{' '}
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.source${
                      businessIdentityData.sources.length !== 1 ? 's' : ''
                    }`,
                    'Sources'
                  )}
                </CompanyInfoSourcesPopover>
              </Col>
            </Row>
          </Col>
          <Col span={12} className="flex-column-content">
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.status`,
                    'Status'
                  )}
                </strong>
              </Col>
              <Col className="col-info">{businessIdentityData.status}</Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.registrationIncorporationDate`,
                    'Registration/Incorporation Date'
                  )}
                </strong>
              </Col>
              <Col className="col-info">
                {i18nFormatDateOnly(
                  businessIdentityData.registrationIncorporationDate,
                  1
                )}
              </Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.companyType`,
                    'Company Type'
                  )}
                </strong>
              </Col>
              <Col className="col-info">{businessIdentityData.companyType}</Col>
            </Row>
            <Row>
              <Col span={12} className="col-info">
                <strong>
                  {translate(
                    `${I18N_BASE_PATH}.companyIdentificationInformation.columns.ownersShareholders`,
                    'Owner(s)/Shareholder(s)'
                  )}
                </strong>
              </Col>
              <Col className="col-info">
                {businessIdentityData.ownersShareholders.map((name) => (
                  <>
                    <span>{name}</span> <br />
                  </>
                )) ?? '-'}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <WrapperCollapsePanel
        businessIdentityData={businessIdentityData}
        collapseOpened={collapseOpened}
        hideRiskFactors={hideRiskFactors}
        hideAttributes={hideAttributes}
      />
    </div>
  );
};

export default BusinessIdentityComponent;
